import React from 'react';
import { Box, Button, FormGroupRow } from '../../../../common/components';
import { InternalButtonBar } from '../../../layout/components';
import { Col, Form, FormGroup, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormGroupInput } from '../../../../common/form/components/components';
import { Field, getFormValues, reduxForm } from 'redux-form';
import AddressFields from '../../../../common/components/ReduxFormField/AddressFields';
import PostCodeField from '../../../../common/components/Postcode/components/PostcodeField';
import AsyncSelectMenu from '../../../../common/components/SelectMenu/AsyncSelectMenu';
import CheckboxUnlabeled from '../../../../common/components/ReduxFormField/CheckboxUnlabeled';
import InfoButton from '../../../../common/components/InfoButton/InfoButton';
import MultiSelectMenu from '../../../../common/components/SelectMenu/MultiSelectMenu';

const BrokerEditForm = ({ resource, handleSubmit, onUpdateBroker }) => {
  return (
    <>
      <Box>
        <Form onSubmit={handleSubmit(onUpdateBroker)}>
          <h2 className="resource-name">{resource.data.attributes.name}</h2>

          <Row>
            <Col sm={6}>
              <Field
                name={'data.attributes.trading_name'}
                label={'Trading Name'}
                labelSize={4}
                colSize={8}
                component={FormGroupInput}
              />
              <Field
                name={'data.attributes.reference'}
                label={'Reference'}
                labelSize={4}
                colSize={8}
                component={FormGroupInput}
              />
              <Field
                name={'data.attributes.phone_number'}
                label="Phone Number"
                labelSize={4}
                colSize={8}
                component={FormGroupInput}
              />
              <AddressFields
                baseName={'data.attributes.address'}
                labelSize={4}
                label={'Address'}
              />
              <FormGroup>
                <Col sm={8} smOffset={4}>
                  <Field
                    name={'data.attributes.address.postcode'}
                    placeholder={'Postcode'}
                    component={PostCodeField}
                  />
                </Col>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <Field
                name={'data.attributes.branch_name'}
                label={'Branch Name'}
                labelSize={4}
                colSize={8}
                component={FormGroupInput}
              />
            </Col>

            <Col sm={6}>
              <FormGroupRow label="Parent Organisation" labelSize={4} fieldSize={8}>
                <Field
                  name="data.relationships.organisation.data.id"
                  url={'/organisations?'}
                  optionValuePath={'id'}
                  component={AsyncSelectMenu}
                />
              </FormGroupRow>
            </Col>
            <Col sm={6}>
              <FormGroupRow
                label="Organisation Channel Access"
                labelSize={4}
                fieldSize={8}
              >
                <Field
                  name={'data.relationships.organisation_channel_access.data'}
                  component={MultiSelectMenu}
                  source={'channels'}
                  sourceKey={'channelsOrgAccess'}
                  filter={'?filter[channel_type]=B2B'}
                  autoFilters={[{ type: 'name', notMatch: 'Fly-sure B2B' }]}
                  isObject
                />
                Note: updating this will update all brokers belonging to the parent
                organisation
              </FormGroupRow>
            </Col>

            <Col sm={6}>
              <Field
                name="data.attributes.metadata.renewals_enabled"
                label={'Enable Renewals'}
                options={[{ label: '', value: true }]}
                labelSize={4}
                infoButton={
                  <InfoButton
                    content={
                      'This simply determines whether customer renewal correspondence is sent from the system – renewals will still be generated and associated documentation will be available for the Broker to use as they require.'
                    }
                  />
                }
                component={CheckboxUnlabeled}
              />
              <Field
                name="data.attributes.metadata.allow_marketing"
                label={'Can use data for marketing'}
                options={[{ label: '', value: true }]}
                labelSize={4}
                component={CheckboxUnlabeled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <InternalButtonBar
                buttons={[
                  {
                    permissions: ['broker.edit'],
                    button: (
                      <Button
                        key={'back'}
                        link={true}
                        to={'/admin/brokers/' + resource.data.id}
                        type={'button'}
                        className="pull-left"
                        bsStyle="default"
                        label="Back"
                      />
                    ),
                  },
                  {
                    permissions: ['broker.edit'],
                    button: (
                      <Button
                        key={'submit'}
                        type={'submit'}
                        className="pull-right"
                        bsStyle="primary"
                        label="Save"
                      />
                    ),
                  },
                ]}
              />
            </Col>
          </Row>
        </Form>
      </Box>
    </>
  );
};

const FORM_NAME = 'EditBrokerForm';
export default compose(
  connect((state, props) => {
    return {
      formValues: getFormValues(FORM_NAME)(state),
      initialValues: props.resource,
    };
  }),
  reduxForm({ form: FORM_NAME }),
)(BrokerEditForm);
